import { isAfter, isBefore, isEqual } from 'date-fns';
import { Component, inject } from '@angular/core';
import { TableRowSelectEvent } from 'primeng/table';
import { injectDispatch } from '@ngrx/signals/events';
import { vesselSpecEvents } from '@navstation-portal/vessels/data-access/store';
import { AppStore } from '@navstation-portal/reporting/data-access/app';
import { vesselReportsEvents } from '@navstation-portal/reporting/data-access/vessel-reports';
import { reportEvents } from '@navstation-portal/reporting/data-access/vessel-report';
import { ReducedOffshoreReport } from '@navstation-portal/reporting/data-model/offshore-reports';
import {
  offshoreReportsEvents,
  OffshoreReportsStore,
} from '@navstation-portal/reporting/data-access/offshore-reports';
import {
  Column,
  DataDisplayType,
} from '@navstation-portal/reporting/data-model/ui';
import { TableComponent } from '@navstation-portal/reporting/ui/shared';
import {
  FilterData,
  ReportFiltersComponent,
} from '../../reporting-page/vessel-reports-page/view-vessel-reports-page/report-filters/report-filters.component';
import { cols } from './view-offshore-constants';

@Component({
  selector: 're-view-offshore-reports-page',
  templateUrl: './view-offshore-reports-page.component.html',
  styleUrl: './view-offshore-reports-page.component.css',
  imports: [ReportFiltersComponent, TableComponent],
})
export class ViewOffshoreReportsPageComponent {
  readonly appStore = inject(AppStore);
  readonly offshoreReportsStore = inject(OffshoreReportsStore);

  readonly offshoreReportsDispatch = injectDispatch(offshoreReportsEvents);
  readonly vesselSpecDispatch = injectDispatch(vesselSpecEvents);
  readonly reportDispatch = injectDispatch(reportEvents);

  columns: Column[] = cols;
  DataType = DataDisplayType;
  filterData: FilterData | undefined;

  setFilterData(filterData: FilterData) {
    this.filterData = filterData;
  }

  filteredReports() {
    if (!this.filterData)
      return this.offshoreReportsStore.entities().slice(0, 10);
    const filtered = this.offshoreReportsStore.entities().filter((report) => {
      if (!this.checkFromDateFilter(report)) return false;
      if (!this.checkToDateFilter(report)) return false;
      return true;
    });

    return filtered.slice(0, 10);
  }

  checkFromDateFilter(report: ReducedOffshoreReport) {
    if (!this.filterData) return true;
    if (!this.filterData.fromDate) return true;
    if (isEqual(report.reportFrom, this.filterData.fromDate)) return true;
    if (isAfter(report.reportFrom, this.filterData.fromDate)) return true;

    return false;
  }

  checkToDateFilter(report: ReducedOffshoreReport) {
    if (!this.filterData) return true;
    if (!this.filterData.toDate) return true;
    if (isEqual(report.reportTo, this.filterData.toDate)) return true;
    if (isBefore(report.reportTo, this.filterData.toDate)) return true;

    return false;
  }

  handleTableRowSelect(event: TableRowSelectEvent<ReducedOffshoreReport>) {
    if (!event.data) return;

    const vesselId = this.appStore.selectedVesselId();
    if (!vesselId) return;

    const report = event.data as ReducedOffshoreReport;
    this.offshoreReportsDispatch.openReport({ vesselId, reportId: report.id });
  }
}
